export enum DeviceByWidthEnum {
  Mobile,
  Tablet,
  MediumScreen,
  HDScreen,
  FullHDScreen,
  UltraWide
}
